import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('highlight', {
    beforeMount(el, binding) {
      // NOTE: takes the term as a parameter so `updated` always uses the
      // fresh binding value (the beforeMount closure would stay stale).
      const highlightText = (searchTerm: string) => {
        if (searchTerm) {
          const regex = new RegExp(`(${searchTerm})`, 'gi');

          el.innerHTML = el.__originalContent || el.innerHTML;

          if (!el.__originalContent) el.__originalContent = el.innerHTML;

          el.innerHTML = el.innerHTML.replace(regex, '<span class="highlighted">$1</span>');
        } else if (el.__originalContent) {
          el.innerHTML = el.__originalContent;
        }
      };

      highlightText(binding.value);

      el.__highlightText = highlightText;
    },
    updated(el, binding) {
      el.__highlightText(binding.value);
    },
    unmounted(el) {
      delete el.__originalContent;
      delete el.__highlightText;
    }
  });
});
